import DOMPurify from 'dompurify';

interface RichTextProps {
  html?: string | null;
  className?: string;
}

// Renders trusted-but-sanitized rich-text HTML (course descriptions, etc.).
// Always run user-authored HTML through DOMPurify before dangerouslySetInnerHTML.
export default function RichText({ html, className = '' }: RichTextProps) {
  if (!html || !html.trim()) return null;
  const clean = DOMPurify.sanitize(html);
  return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: clean }} />;
}
